import React, { isValidElement } from 'react';
import { Chip, Theme, Typography, useTheme } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import { VpBorderRadius } from '../../features/variety-planner/styles';

const makeStyles = (theme: Theme) => ({
  customChip: {
    fontSize: theme.typography.caption.fontSize,
    borderRadius: VpBorderRadius.SMALL,
    backgroundColor: theme.palette.appWhite,
    border: `1px solid ${theme.palette.questionsForm.formBlue}`,
    color: theme.palette.questionsForm.formGrey,
    padding: theme.spacing(0.5, 0.75),
    marginRight: theme.spacing(1),
    height: 'auto',
    marginTop: theme.spacing(1),

    '& .MuiChip-label': {
      lineHeight: theme.typography.caption.lineHeight,
      display: 'block',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflow: 'visible',
      paddingLeft: 0,
    },

    '& .MuiChip-deleteIcon': {
      fontSize: '20px',
      marginRight: 0,
      color: theme.palette.questionsForm.formBlue,
      '&:hover': {
        color: theme.palette.questionsForm.formHoverState,
      },
    },
  },
});

interface AppChipProps {
  label: string | React.ReactNode;
  onDelete: () => void;
}

const AppChip: React.FC<Readonly<AppChipProps>> = ({ label, onDelete }) => {
  const theme = useTheme();
  const styles = makeStyles(theme);

  const renderLabel = () => {
    if (isValidElement(label)) {
      return (
        <Typography
          variant="appCaption"
          color="questionsForm.formGrey"
          component="span"
        >
          {label}
        </Typography>
      );
    }

    return (
      <Typography variant="appCaption" color="questionsForm.formGrey">
        {label}
      </Typography>
    );
  };

  return (
    <Chip
      variant="outlined"
      label={renderLabel()}
      sx={styles.customChip}
      deleteIcon={<CloseOutlinedIcon />}
      onDelete={onDelete}
    />
  );
};

export default AppChip;
